import SearchInput from './searchInput'

export default SearchInput
